import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@cae/cobalt-react/css/main.css";

import App from "./App.tsx";
import { enableMocking } from "./config/enableMocking.ts";

const useMockFn = enableMocking();

useMockFn.then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});
